module.exports = __webpack_public_path__ + "asana-logo.png";